export function createNavWidthCalculator(widths) {
    return function navWidthCalculator(type, enabled) {
        const widthsForType = widths[type];
        return enabled ? widthsForType.enabled : widthsForType.disabled;
    };
}
